import {
  DELIVERY_ERROR,
  DELIVERY_RESET,
  GET_DELIVERY,
  GET_DELIVERY_CONTACT,
  CREATE_DELIVERY_SUCCESS,
  EDIT_DELIVERY_SUCCESS,
  CREATE_DELIVERY_FAILED,
  EDIT_DELIVERY_FAILED,
  CREATE_DELIVERY_PENDING,
} from "../constants/deliveryConstants";
import { history } from "../Root";
import Axios from "axios";
import { API_ROOT } from "../components/utils/api-config";
import { setAlert } from "./alertAction";
let token = "Bearer " + localStorage.getItem("token");
const auth = {
  headers: {
    Authorization: token,
  },
};

export const requestDelivery = (id) => (dispatch) => {
  Axios.get(`${API_ROOT}/deliveries/${id}/`, auth)
    .then((response) =>
      dispatch({ type: GET_DELIVERY, payload: response.data })
    )
    .catch((error) => {
      dispatch({ type: DELIVERY_ERROR, payload: error }),
        dispatch(setAlert("Delivery not exist", "danger"));
      history.push(`/logistics`);
    });
};
export const postDelivery = (formData, config) => (dispatch) => {
  dispatch({ type: CREATE_DELIVERY_PENDING });
  Axios.post(`${API_ROOT}/deliveries/`, formData, auth, config)
    .then(({ data }) => {
      dispatch({ type: CREATE_DELIVERY_SUCCESS, payload: data });
      dispatch(setAlert("Delivery scheduled", "success"));
      history.push(`/deliveries/${data.id}`);
    })
    .catch((error) =>
      dispatch({ type: CREATE_DELIVERY_FAILED, payload: error })
    );
};
export const editDelivery = (delivery) => (dispatch) => {
  dispatch({ type: EDIT_DELIVERY_SUCCESS, payload: delivery });
  dispatch(setAlert(delivery, "success"));
  // .catch((error) =>
  //   dispatch({ type: EDIT_DELIVERY_FAILED, payload: error })
  // );
};

export const requestContact = (id) => (dispatch) => {
  Axios.get(`${API_ROOT}/deliveries/contact?id=${id}`, auth)
    .then((response) =>
      dispatch({ type: GET_DELIVERY_CONTACT, payload: response.data })
    )
    .catch((error) => {
      dispatch({ type: DELIVERY_ERROR, payload: error }),
        dispatch(setAlert("Cannot find your info", "danger"));
    });
};

export const resetDelivery = () => {
  return { type: DELIVERY_RESET };
};
